import { isAndroid, isIOS } from '@platform-ui/device-info';
export const getPlatformKey = platform => {
  if (platform) {
    return platform;
  }
  if (isIOS()) {
    return 'ios';
  }
  if (isAndroid()) {
    return 'android';
  }
  return 'desktop';
};